import React from 'react';
import { Card, TextField as MuiTextField } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import FormikRemoteAutocompleteField from '../MasterData/components/FormikRemoteAutocompleteField';
import { mastersApi } from '../../../services/MasterDataServices';
import { TextField } from 'formik-mui';

export default function CatalogueEntryOne(props) {
  const { code } = props;
  const { values, touched, errors, setFieldValue } = useFormikContext();

  const loadOwnerships = React.useCallback((params) => mastersApi('ownerships', 'get', null, params), []);
  const loadAccessionNos = React.useCallback((params) => mastersApi('accession_nos', 'get', null, params), []);
  const loadObjectGroups = React.useCallback((params) => mastersApi('object_groups', 'get', null, params), []);
  const loadSubGroups = React.useCallback((params) => {
    const ogId = values?.translations?.[code]?.classification;
    const merged = { ...params, object_group_id: ogId || undefined };
    return mastersApi('object_sub_groups', 'get', null, merged);
  }, [values?.translations, code]);
  const loadAcquisitions = React.useCallback((params) => mastersApi('acquisitions', 'get', null, params), []);
  const loadMaterials = React.useCallback((params) => mastersApi('materials', 'get', null, params), []);

  const getSelected = (options, id) => {
    if (!id) return null;
    return (options || []).find(opt => opt?.id === id) || null;
  };

  const fieldMeta = (name) => {
    const fieldTouched = touched?.translations?.[code]?.[name];
    const fieldError = errors?.translations?.[code]?.[name];
    return {
      error: Boolean(fieldTouched && fieldError),
      helperText: fieldTouched && fieldError ? fieldError : '',
    };
  };

  const commonLabelProps = {
    style: { fontSize: 14, color: '#929191' },
    shrink: true,
  };

  return (
    <Card className={'box-shadow'} sx={{ p: 4 }}>
      <FormikRemoteAutocompleteField
        name={`translations.${code}.ownership`}
        label={'Ownership'}
        loadOptions={loadOwnerships}
        getOptionLabel={(o) => o?.name || o?.code || ''}
        onChange={(v) => setFieldValue(`translations.${code}.ownership`, v?.id || null)}
        sx={{ mt: 1.5 }}
      />
      <Field
        component={TextField}
        variant={'outlined'}
        size={'small'}
        fullWidth
        label={'Accession No.'}
        name={`translations.${code}.accession_no`}
        InputLabelProps={{
          style: { fontSize: 14, color: '#929191' },
          shrink: true
        }}
        sx={{ mt: 1.5 }}
      />
      <FormikRemoteAutocompleteField
        name={`translations.${code}.classification`}
        label={'Classification'}
        loadOptions={loadObjectGroups}
        getOptionLabel={(o) => o?.name || o?.code || ''}
        onChange={(v) => {
          setFieldValue(`translations.${code}.classification`, v?.id || null);
          setFieldValue(`translations.${code}.sub_group`, null);
        }}
        sx={{ mt: 1.5 }}
      />
      {/* Object Type field removed as requested */}
      <FormikRemoteAutocompleteField
        name={`translations.${code}.sub_group`}
        label={'Sub Group'}
        loadOptions={loadSubGroups}
        getOptionLabel={(o) => o?.name || o?.code || ''}
        onChange={(v) => setFieldValue(`translations.${code}.sub_group`, v?.id || null)}
        reloadDeps={values?.translations?.[code]?.classification}
        sx={{ mt: 1.5 }}
      />
      <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Object Name'}
        name={`translations.${code}.object_name`}
        sx={{ mt: 1.5 }}
        InputLabelProps={{
          style: { fontSize: 14, color: '#929191' }
        }} />
      <FormikRemoteAutocompleteField
        name={`translations.${code}.acquisition`}
        label={'Acquisition'}
        loadOptions={loadAcquisitions}
        getOptionLabel={(o) => o?.name || o?.code || ''}
        onChange={(v) => setFieldValue(`translations.${code}.acquisition`, v?.id || null)}
        sx={{ mt: 1.5 }}
      />
      <FormikRemoteAutocompleteField
        name={`translations.${code}.material`}
        label={'Materials'}
        loadOptions={loadMaterials}
        getOptionLabel={(o) => o?.name || o?.code || ''}
        onChange={(v) => setFieldValue(`translations.${code}.material`, v?.id || null)}
        sx={{ mt: 1.5 }}
      />
    </Card>
  );
}